import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
export const ContainerSidebar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 8px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;
interface IIcon {
  width: number;
}
export const Block = styled.div<IIcon>`
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: absolute;
  top: 0px;
  right: 0;
  width: 261px;
  z-index: 10;
  cursor: auto;
`;
export const CircleDiv = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  color: ${beam.color.pureWhite};
  background: ${beam.color.primaryBlue};

  border-radius: 50%;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  font-size: 10px;
  font-weight: 700;
  right: -5px;
  bottom: -5px;
  width: 14px;
  height: 14px;
`;

export const Icon = styled.div<IIcon>`
  min-width: ${({ width }) => width}px;
  width: ${({ width }) => width}px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const MenuIcon = styled.div`
  padding-top: 5px;
  cursor: pointer;
`;
